import { window } from "global";
import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import { useLocation, matchPath, Link } from "react-router-dom";
import { useGlobal } from "reactn";
import { useUserPremiumState } from "lib/hooks/userHooks";
import CountdownTimer from "components/CountdownTimer";
import ctaYasuo from "images/onlyguides/cta/cta_yasuo.png";
import ctaLux from "images/onlyguides/cta/cta_lux.png";
import ctaJinx from "images/onlyguides/cta/cta_jinx.png";
import ctaAkali from "images/onlyguides/cta/cta_akali.png";
import popupZeri from "images/onlyguides/cta/popup_zeri.png";
import { ReactComponent as IconX } from "svg/x.svg";
import { ReactComponent as OGBoxLogo } from "svg/onlyguides-box-logo.svg";
import { ReactComponent as OGTextLogo } from "svg/onlyguides-text-logo.svg";

import { OG_CONTEST_ALERT_LIMIT, OG_CONTEST_DEADLINE } from "lib/constants";

const ctaImages = [ctaYasuo, ctaLux, ctaJinx, ctaAkali];

function getRandomImage() {
  return ctaImages[Math.floor(Math.random() * ctaImages.length)];
}

function isHidden(pathname) {
  return matchPath(pathname, {
    path: ["/support-us", "/about", "/faq", "/privacy-policy", "/privacy-shield", "/careers", "/terms-of-service"],
    exact: true,
    strict: false,
  });
}

const OG_CTA_COOKIE = "og-cta";
export const OG_CTA_UTM_BUILD = "BuildPage";
export const OG_CTA_UTM_POPUP = "PopUp";

const Upcoming = (props) => {
  const { closable, popupDelay, utmCampaign } = props;
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const location = useLocation();
  const popupTimeout = useRef();
  const [ctaImage, setCTAImage] = useState(getRandomImage());
  const isPopup = !isNaN(popupDelay) && popupDelay > 0;
  const [show, setShow] = useState(
    (() => {
      if (isPopup) {
        return false;
      } else if (closable) {
        return (window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide";
      } else {
        return true;
      }
    })(),
  );

  const hidden = isHidden(location.pathname);

  useEffect(() => {
    if (isPopup) {
      if ((window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide") {
        popupTimeout.current = setTimeout(() => {
          setShow(true);
        }, popupDelay);
      }
    }

    return () => popupTimeout.current && clearTimeout(popupTimeout.current);
  }, []);

  useEffect(() => {
    setCTAImage(getRandomImage);
  }, [location.pathname]);

  const onHide = () => {
    if (window) {
      localStorage.setItem(OG_CTA_COOKIE, "hide");
    }
    setShow(false);
    popupTimeout.current && clearTimeout(popupTimeout.current);
  };

  if (hidden || !show || loggingIn || isPremium) {
    return null;
  }

  return (
    <div className={classnames("onlyguides-cta onlyguides-cta_upcoming", { "onlyguides-cta_upcoming_popup": isPopup })}>
      <div className="bg-image">
        <img src={ctaImage} />
      </div>
      <div className="og-logo-container">
        <OGBoxLogo className="og-box-logo" />
        <OGTextLogo className="og-text-logo" />
      </div>
      <div className="text-box">
        <span>
          We’re hosting a{" "}
          <strong style={{ color: "#3273FA" }}>
            <i>$24,000</i>
          </strong>
          <br />
          guide writing contest.
        </span>
      </div>
      <a
        className="btn-blue btn-blue_hover og-promos_button"
        href={`https://www.onlyguides.com/guide/s12-kickoff-contest-24000-over-two-months-31-1-2022-185158?utm_source=UGG&utm_campaign=${utmCampaign}`}
        target="_blank"
      >
        View Contest Details
      </a>
      {closable && (
        <div className="close" onClick={onHide}>
          <IconX className="x-icon" />
        </div>
      )}
    </div>
  );
};

const Submission = (props) => {
  const { closable, popupDelay, utmCampaign } = props;
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const location = useLocation();
  const popupTimeout = useRef();
  const [ctaImage, setCTAImage] = useState(getRandomImage());
  const isPopup = !isNaN(popupDelay) && popupDelay > 0;
  const [show, setShow] = useState(
    (() => {
      if (isPopup) {
        return false;
      } else if (closable) {
        return (window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide";
      } else {
        return true;
      }
    })(),
  );

  const hidden = isHidden(location.pathname);

  useEffect(() => {
    if (isPopup) {
      if ((window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide") {
        popupTimeout.current = setTimeout(() => {
          setShow(true);
        }, popupDelay);
      }
    }

    return () => popupTimeout.current && clearTimeout(popupTimeout.current);
  }, []);

  useEffect(() => {
    setCTAImage(getRandomImage);
  }, [location.pathname]);

  const onHide = () => {
    if (window) {
      localStorage.setItem(OG_CTA_COOKIE, "hide");
    }
    setShow(false);
    popupTimeout.current && clearTimeout(popupTimeout.current);
  };

  if (hidden || !show || loggingIn || isPremium) {
    return null;
  }

  return (
    <div className={classnames("onlyguides-cta onlyguides-cta_submission", { "onlyguides-cta_submission_popup": isPopup })}>
      <div className="bg-image">{window && <img src={ctaImage} />}</div>
      <div className="og-logo-container">
        <OGBoxLogo className="og-box-logo" />
        <OGTextLogo className="og-text-logo" />
      </div>
      <div className="text-box">
        <span className="live-tag">LIVE:</span>
        <span>
          &nbsp;
          <strong style={{ color: "#3273FA" }}>
            <i>$24,000</i>
          </strong>{" "}
          in prizes
          <br /> for your guide.
        </span>
      </div>
      <div className="flex align-items-center" style={{ position: "relative", width: "100%" }}>
        <CountdownTimer endDate={OG_CONTEST_DEADLINE} autoAlert={OG_CONTEST_ALERT_LIMIT} />
        <a
          className="btn-blue btn-blue_hover og-promos_button"
          href={`https://www.onlyguides.com/guide/s12-kickoff-contest-24000-over-two-months-31-1-2022-185158?utm_source=UGG&utm_campaign=${utmCampaign}2`}
          target="_blank"
        >
          View Contest Details
        </a>
      </div>
      {closable && (
        <div className="close" onClick={onHide}>
          <IconX className="x-icon" />
        </div>
      )}
    </div>
  );
};

const Popup = (props) => {
  const { closable, popupDelay, utmCampaign } = props;
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const location = useLocation();
  const popupTimeout = useRef();
  const isPopup = !isNaN(popupDelay) && popupDelay > 0;
  const [show, setShow] = useState(
    (() => {
      if (isPopup) {
        return false;
      } else if (closable) {
        return (window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide";
      } else {
        return true;
      }
    })(),
  );

  const hidden = isHidden(location.pathname);

  useEffect(() => {
    if (isPopup) {
      if ((window && localStorage.getItem(OG_CTA_COOKIE)) !== "hide") {
        popupTimeout.current = setTimeout(() => {
          setShow(true);
        }, popupDelay);
      }
    }

    return () => popupTimeout.current && clearTimeout(popupTimeout.current);
  }, []);

  const onHide = () => {
    if (window) {
      localStorage.setItem(OG_CTA_COOKIE, "hide");
    }
    setShow(false);
    popupTimeout.current && clearTimeout(popupTimeout.current);
  };

  if (hidden || !show || loggingIn || isPremium) {
    return null;
  }

  return (
    <div
      className={classnames("onlyguides-cta onlyguides-cta_submission onlyguides-popup_submission", {
        "onlyguides-cta_submission_popup": isPopup,
      })}
    >
      <div className="bg-image">
        <img src={popupZeri} />
        <div className="gradient" />
      </div>
      <div className="og-logo-container">
        <OGBoxLogo className="og-box-logo" />
        <OGTextLogo className="og-text-logo" />
      </div>
      <div className="text-box">
        <span className="live-tag">LIVE:</span>
        <span>
          &nbsp;
          <strong style={{ color: "#3273FA" }}>
            <i>$24,000</i>
          </strong>{" "}
          in prizes
          <br /> for your guide.
        </span>
      </div>
      <div className="flex align-items-center" style={{ position: "relative", width: "100%" }}>
        <CountdownTimer endDate={OG_CONTEST_DEADLINE} autoAlert={OG_CONTEST_ALERT_LIMIT} />
        <a
          className="btn-blue btn-blue_hover og-promos_button"
          href={`https://www.onlyguides.com/guide/s12-kickoff-contest-24000-over-two-months-31-1-2022-185158?utm_source=UGG&utm_campaign=${utmCampaign}2`}
          target="_blank"
        >
          View Contest Details
        </a>
      </div>
      {closable && (
        <div className="close" onClick={onHide}>
          <IconX className="x-icon" />
        </div>
      )}
    </div>
  );
};

export default {
  Upcoming,
  Submission,
  Popup,
};
